'use strict';

var util = angular.module('gymsystem.util');

util.factory('EntryService', ['$q', '$modal', function($q, $modal) {
    var EntryService = {};

    EntryService.entyCardDialog = function(customer) {
        return $modal.open({
            templateUrl: '/components/entry/entrycarddialog.html',
            controller: 'EntryCardDialog',
            resolve: {
                customer: function() {
                    return customer;
                }
            }
        }).result;
    };

    return EntryService;
}]);

util.controller('EntryCardDialog', ['$scope', 'customer', 'confirm', 'server', function($scope, customer, confirm, server) {
    $scope.data = {};
    $scope.customer = customer;

    if ($scope.customer.hasCard) {
        server.get('/api/card/get', {user_id: $scope.customer.id}).then(function(card) {
            $scope.data.pin = card.pin;
            $scope.data.manual = card.cardId;
        });
    }

    $scope.save = function() {
        $scope.$close({
            value: $scope.data.card || $scope.data.manual,
            pin: $scope.data.pin,
            manual: !!$scope.data.manual
        });
    };
    $scope.remove = function() {
        confirm.show('Are you sure you want to remove the card/tag?').then(function() {
            $scope.$close({
                remove: true
            });
        });
    };

    $scope.ableToSave = function() {
        if($scope.data.pin)
        {
            if(!/^\d+$/.test($scope.data.pin)) {
                return false;
            }
        }
        return $scope.data.manual || $scope.data.card;
    };
}]);
